import { createContext } from "react";

export const AppContext = createContext();

export const SocketContext = createContext();

////for yinitial commit
